<template>
  <core-view>
    <v-card>
      <v-card-title class='d-flex justify-space-between my-1'>
        <b>
          {{titulo}}
        </b>
        <v-btn outlined v-if="resumo" class="btn-resumo" @click="$_mudarTabela()">
          <v-icon class="mdi" :class="mostrarResumo ? 'mdi-table' : 'mdi-chart-bar'"></v-icon>
          {{ mostrarResumo ? 'Ver Detalhes' : 'Ver Resumo' }}
        </v-btn>

      </v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle class='d-flex justify-space-between'>
        <b>
          Período:
        </b>
        <b>
          {{ periodo }}
        </b>
      </v-card-subtitle>

      <v-card-text v-if="dados?.length > 0 && !mostrarResumo">
          <simplebar ref="simplebar" data-simplebar class="table-container mx-auto " :autoHide="false" >
          <table class="table" :style="{width: 'max-content' }">

            <tr v-if="grupos.length" class="grupo-header">
              <th
                v-for="(grupo, index) in grupos"
                :key="index"
                :colspan="grupo.colspan"
                :class="grupo.class"
                color="white"
              >
                {{ grupo.label.toUpperCase() }}
              </th>
            </tr>

            <tr class="table__tr colunas" ref="scroll-target" :style="{top: grupos.length ? '21.5px' : '0px' }">
              <th v-for="(col, index) in colunas" :key="col.key + '-' + index" :class="col.headerClasse">
                  {{ col.nome.toUpperCase() }}
              </th>
            </tr>

            <tr v-for="(item, index) in dados" :key="index" @click="$_onClickItem(item)"
                :class="{ 'table__tr': true, 'table__tr--dark-background': index % 2 === 0 }">
                <td v-for="(col, index) in colunas"
                 :key="col.key + '-' + index"
                 :style="{height: heightLinha}"
                 :class="col.linhaClasse">
                <slot v-if="col.mascara" :name="col.key" :item="item">
                  {{ FormataData(item[col.key], col.mascara) }}
                </slot>
                <slot v-else-if="col.decimal" :name="col.key" :item="item">
                  {{ item[col.key] && Number(item[col.key]) !== 0 ? $_formatarDecimal(item[col.key], col.casas) : '- - -' }}
                </slot>
                <slot v-else-if="col.badge" :name="col.key" :item="item">
                  <span
                    :class="col.badge.somenteIcone ? 'col-badge col-badge--icone' : 'col-badge'"
                    :style="$_badgeEstilo(item[col.key], col.badge)"
                  >
                    <span class="col-badge__bolinha"></span>
                    <template v-if="!col.badge.somenteIcone">{{ $_badgeLabel(item[col.key], col.badge) }}</template>
                  </span>
                </slot>
                <slot v-else :name="col.key" :item="item">
                  {{ item[col.key] || '- - -' }}
                </slot>
              </td>
            </tr>

        </table>
        </simplebar>
      </v-card-text>

      <v-card-text v-else-if="dados?.length > 0 && mostrarResumo">
        <div class="resumo-agrupamentos-wrapper">
          <simplebar data-simplebar class="mx-auto" :autoHide="false" >
          <div class="resumo-agrupamentos">
            <div v-for="(agr, index) in agrupamentos"
              :key="index"
              class="resumo-tab">
            <v-btn
              outlined
              :aria-selected="index === indiceAgrupamentoAtivo"
              @click="$_mudarResumo(index)"
              :class="[
                'btn-agrupamento',
                { 'btn-agrupamento--ativo': index === indiceAgrupamentoAtivo }
              ]"
            >
              {{ agr.label }}
            </v-btn>
            </div>
          </div>
          </simplebar>
         </div>

          <simplebar ref="simplebar" data-simplebar class="table-container mx-auto" :style="{maxHeight: '460px !important'}" :autoHide="false" >
          <table v-if="mostrarResumo" class="table mx-auto" >

          <!-- HEADER -->
          <thead>
            <tr class="table__tr colunas">
              <th v-for="(col, index) in colunasResumoFinal" :key="col.key + '-' + index" :class="col.headerClasse">
                {{ col.label.toUpperCase() }}
              </th>
            </tr>
          </thead>

          <!-- BODY (SEM TOTAL) -->
          <tbody>
            <tr
              v-for="(item, index) in resumoComTotal.filter(i => !i.__isTotal)"
              :key="index"
              :class="{
                'table__tr': true,
                'table__tr--dark-background': index % 2 === 0
              }"
            >
              <td v-for="(col, index) in colunasResumoFinal"
                  :style="{height: heightLinha}"
                  :key="col.key + '-' + index"
                  :class="col.linhaClasse">

                {{ formatarValor(item[col.key], col.tipo) }}

              </td>
            </tr>
          </tbody>

          <!-- FOOTER (TOTAL STICKY) -->
          <tfoot>
            <tr
              v-for="(item, index) in resumoComTotal.filter(i => i.__isTotal)"
              :key="'total-' + index"
              class="table__tr table__tr--total row-total sticky-total"
            >
              <td v-for="(col, index) in colunasResumoFinal"
                  :style="{height: heightLinha}"
                  :key="col.key + '-' + index"
                  :class="[
                    col.linhaClasse,
                    'table__total-cell'
                  ]">

                <span v-if="col.tipo === 'string'">
                  {{ item[col.key] }}
                </span>
                <span v-else>
                  {{ formatarValor(item[col.key], col.tipo) }}
                </span>

              </td>
            </tr>
          </tfoot>

        </table>
        </simplebar>
      </v-card-text>

      <v-card-text v-else class="empty-state">
        <v-progress-circular v-if="loading"
          indeterminate
          size="50"
          color="grey"
          class="d-block mx-auto mt-10"
        ></v-progress-circular>
        <div v-else class="empty-state-container">
          <v-icon x-large class="empty-state-icon">mdi-inbox-outline</v-icon>
          <p class="empty-state-title"> {{tituloVazio}} </p>
          <p class="empty-state-subtitle">Não há registros para o período selecionado</p>
        </div>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </core-view>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

import CoreView from '@/components/core/view/Index.vue';
import moment from 'moment';

export default {
  name: 'ViewRecebimento',

  components: {
    CoreView,
    simplebar,
  },

  props: {
    colunas: Array,
    dados: Array,
    titulo: String,
    periodo: String,
    tituloVazio: String,
    agrupamentos: Array,
    loading: Boolean,
    heightLinha: {
      type: String,
      default: '50px',
    },
    resumo: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      mostrarResumo: false,
      indiceAgrupamentoAtivo: 0,
    };
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    agrupamentoAtivo() {
      return this.agrupamentos[this.indiceAgrupamentoAtivo] || null;
    },
    grupos() {
      const cols = [];
      let cursor = 0;
      const totalColunas = this.colunas.length;

      // 1. Identificar blocos de grupos contíguos
      const grupos = [];

      this.colunas.forEach((coluna, index) => {
        if (!coluna.grupo) return;

        const ultimoGrupo = grupos[grupos.length - 1];
        if (!ultimoGrupo || ultimoGrupo.nome !== coluna.grupo) {
          grupos.push({
            nome: coluna.grupo,
            inicio: index,
            fim: index,
          });
        } else {
          ultimoGrupo.fim = index;
        }
      });

      // 2. Montar células do header
      if (grupos.length) {
        grupos.forEach((grupo) => {
        // Espaço antes do grupo
          if (cursor < grupo.inicio) {
            cols.push({
              colspan: grupo.inicio - cursor,
              label: '',
              class: 'grupo-empty',
            });
          }

          // Célula do grupo
          cols.push({
            colspan: grupo.fim - grupo.inicio + 1,
            label: grupo.nome,
            class: '',
          });

          cursor = grupo.fim + 1;
        });

        // Espaço final
        if (cursor < totalColunas) {
          cols.push({
            colspan: totalColunas - cursor,
            label: '',
            class: 'grupo-empty',
          });
        }
      }

      return cols;
    },
    resumoResolvido() {
      if (!this.resumo || !this.dados?.length) return [];

      const { colunas } = this.resumo;
      const { groupBy } = this.agrupamentoAtivo;
      const map = new Map();

      this.dados.forEach((item) => {
        const chave = groupBy.map((k) => item[k]).join('|');

        if (!map.has(chave)) {
          const base = {};

          // groupBy (strings)
          groupBy.forEach((k) => {
            base[k] = item[k];
          });

          // inicializa colunas do resumo
          colunas.forEach((col) => {
            if (col.tipo === 'count') base[col.key] = 0;
            if (col.tipo === 'sum') base[col.key] = 0;
            if (col.tipo === 'media') {
              base[col.key] = 0; // será a média final
              base[`${col.key}__sum`] = 0; // acumulador
              base[`${col.key}__count`] = 0; // contador (apenas valores não-zero)
            }
            if (col.tipo === 'expressao') base[col.key] = 0;
          });

          map.set(chave, base);
        }

        const acc = map.get(chave);

        colunas.forEach((col) => {
          if (col.tipo === 'count') {
            acc[col.key] += 1;
          }

          if (col.tipo === 'sum') {
            acc[col.key] += Number(item[col.key] || 0);
          }

          if (col.tipo === 'media') {
            const valor = Number(item[col.key] || 0);
            acc[`${col.key}__sum`] += valor;
            // Conta apenas valores diferentes de zero
            if (valor !== 0) {
              acc[`${col.key}__count`] += 1;
            }
          }

          if (col.tipo === 'expressao' && col.expressao) {
            acc[col.key] += this.$_calcularExpressao(col.expressao, item);
          }
        });
      });

      // Calcula as médias
      const resultado = Array.from(map.values());
      resultado.forEach((item) => {
        colunas.forEach((col) => {
          if (col.tipo === 'media') {
            const sum = item[`${col.key}__sum`] || 0;
            const count = item[`${col.key}__count`] || 0;
            // eslint-disable-next-line no-param-reassign
            item[col.key] = count > 0 ? sum / count : 0;
            // Remove campos temporários
            // eslint-disable-next-line no-param-reassign
            delete item[`${col.key}__sum`];
            // eslint-disable-next-line no-param-reassign
            delete item[`${col.key}__count`];
          }
        });
      });

      return resultado;
    },
    resumoComTotal() {
      if (!this.resumoResolvido?.length) return [];

      const keysOrdenacao = this.colunasAgrupamentoAtivo.map((c) => c.key);

      // 1️⃣ Clona e ordena apenas os itens normais
      const itensOrdenados = [...this.resumoResolvido].sort((a, b) => {
        for (let i = 0; i < keysOrdenacao.length; i += 1) {
          const key = keysOrdenacao[i];
          const valorA = a[key] || '';
          const valorB = b[key] || '';
          const cmp = valorA.localeCompare(valorB, 'pt-BR', { sensitivity: 'base' });
          if (cmp !== 0) return cmp;
        }
        return 0;
      });

      // 2️⃣ Monta TOTAL
      const total = {
        __isTotal: true,
      };

      this.colunasAgrupamentoAtivo.forEach((col, i) => {
        total[col.key] = i === 0 ? 'TOTAL' : '';
      });

      this.resumo.colunas.forEach((col) => {
        if (col.tipo === 'string') {
          total[col.key] = 'TOTAL';
        }

        if (col.tipo === 'count' || col.tipo === 'sum' || col.tipo === 'expressao') {
          total[col.key] = 0;
        }

        if (col.tipo === 'media') {
          total[col.key] = 0;
          total[`${col.key}__sum`] = 0;
          total[`${col.key}__count`] = 0;
        }
      });

      // 3️⃣ Soma valores
      itensOrdenados.forEach((item) => {
        this.resumo.colunas.forEach((col) => {
          if (col.tipo === 'count' || col.tipo === 'sum' || col.tipo === 'expressao') {
            total[col.key] += Number(item[col.key] || 0);
          }

          if (col.tipo === 'media') {
            const valor = Number(item[col.key] || 0);
            total[`${col.key}__sum`] += valor;
            // Conta apenas valores diferentes de zero
            if (valor !== 0) {
              total[`${col.key}__count`] += 1;
            }
          }
        });
      });

      // 4️⃣ Calcula média do total
      this.resumo.colunas.forEach((col) => {
        if (col.tipo === 'media') {
          const sum = total[`${col.key}__sum`] || 0;
          const count = total[`${col.key}__count`] || 0;
          total[col.key] = count > 0 ? sum / count : 0;
          // Remove campos temporários
          delete total[`${col.key}__sum`];
          delete total[`${col.key}__count`];
        }
      });

      // 5️⃣ Retorna ordenado + total no final
      return [
        ...itensOrdenados,
        total,
      ];
    },
    colunasAgrupamentoAtivo() {
      if (!this.agrupamentoAtivo) return [];
      const { coluna } = this.agrupamentoAtivo;
      const lista = Array.isArray(coluna) ? coluna : [coluna];
      return lista.map((c) => ({ ...c, tipo: 'string' }));
    },
    colunasResumoFinal() {
      if (!this.agrupamentoAtivo) return this.resumo.colunas;

      // remove qualquer string anterior
      const colunasNumericas = this.resumo.colunas.filter(
        (c) => c.tipo !== 'string',
      );

      return [
        ...this.colunasAgrupamentoAtivo,
        ...colunasNumericas,
      ];
    },
  },

  methods: {
    $_isEmpty(obj) {
      return !obj || Object.keys(obj).length === 0;
    },
    FormataData(date, mask = 'DD/MM/YYYY') {
      return date ? moment.utc(date).format(mask) : '- - -';
    },
    $_Mascara(string) {
      return string.slice(0, -1);
    },
    $_onClickItem(item) {
      this.$emit('clicou', item);
    },
    /**
     * Calcula expressões com operadores entre colunas ou valores
     * Exemplo: { operacoes: [{coluna1: 'peso_bruto', operador: '/', coluna2: 25}] }
     * coluna2 pode ser um nome de coluna (string) ou um valor numérico direto
     * @param {Object} expressao - Objeto com a estrutura da expressão
     * @param {Object} item - Item de dados para extrair valores
     * @returns {number} Resultado da expressão
     */
    $_calcularExpressao(expressao, item) {
      if (!expressao || !expressao.operacoes) return 0;

      try {
        let resultado = 0;

        expressao.operacoes.forEach((op, index) => {
          const valor1 = Number(item[op.coluna1] || 0);
          let novoValor = 0;

          if (!op.coluna2) {
            // Operação unária
            novoValor = valor1;
          } else {
            // Operação binária
            // Detecta se coluna2 é um valor numérico direto ou um nome de coluna
            let valor2 = 0;
            if (typeof op.coluna2 === 'number') {
              // É um valor numérico direto
              valor2 = op.coluna2;
            } else {
              // É um nome de coluna
              valor2 = Number(item[op.coluna2] || 0);
            }

            switch (op.operador) {
              case '+':
                novoValor = valor1 + valor2;
                break;
              case '-':
                novoValor = valor1 - valor2;
                break;
              case '*':
                novoValor = valor1 * valor2;
                break;
              case '/':
                novoValor = valor2 !== 0 ? valor1 / valor2 : 0;
                break;
              default:
                novoValor = valor1;
            }
          }

          if (index === 0) {
            resultado = novoValor;
          } else {
            // Combina com resultado anterior usando operador
            const opAnterior = expressao.operacoes[index - 1];
            switch (opAnterior.operador) {
              case '+':
                resultado += novoValor;
                break;
              case '-':
                resultado -= novoValor;
                break;
              case '*':
                resultado *= novoValor;
                break;
              case '/':
                resultado = novoValor !== 0 ? resultado / novoValor : 0;
                break;
              default:
                resultado = novoValor;
            }
          }
        });

        return resultado;
      } catch (error) {
        console.error('Erro ao calcular expressão:', error);
        return 0;
      }
    },
    /**
     * Calcula expressões aplicadas ao resultado total
     * Exemplo: { operador: '/', valor: 25 } - divide o total por 25
     * @param {Object} expressaoTotal - Objeto com operador e valor
     * @param {number} totalAtual - Valor total atual
     * @returns {number} Resultado da expressão no total
     */
    $_calcularExpressaoTotal(expressaoTotal, totalAtual) {
      if (!expressaoTotal) return totalAtual;
      console.log(totalAtual, Number(expressaoTotal.valor), Number(expressaoTotal.valor || 0));
      try {
        const valor = Number(expressaoTotal.valor || 0);

        switch (expressaoTotal.operador) {
          case '+':
            return totalAtual + valor;
          case '-':
            return totalAtual - valor;
          case '*':
            return totalAtual * valor;
          case '/':
            return valor !== 0 ? totalAtual / valor : 0;
          default:
            return totalAtual;
        }
      } catch (error) {
        console.error('Erro ao calcular expressão do total:', error);
        return totalAtual;
      }
    },
    formatarValor(valor, tipo) {
      if (tipo === 'string') return valor || '- - -';

      if (tipo === 'count') return valor;

      if (tipo === 'media') {
        return Number(valor) !== 0 ? valor.toLocaleString(
          'pt-BR',
          { minimumFractionDigits: 2, maximumFractionDigits: 2 },
        ) : '- - -';
      }
      if (tipo === 'sum' || tipo === 'expressao') {
        return Number(valor) !== 0 ? valor.toLocaleString('pt-BR') : '- - -';
      }
      return valor;
    },
    /**
    /**
     * Formata um número decimal respeitando a quantidade de casas definida na coluna.
     * Se 'casas' não for declarado, usa o toLocaleString padrão sem opções.
     */
    $_formatarDecimal(valor, casas) {
      const num = Number(valor);
      if (casas !== undefined && casas !== null) {
        return num.toLocaleString('pt-BR', {
          minimumFractionDigits: casas,
          maximumFractionDigits: casas,
        });
      }
      return num.toLocaleString();
    },

    /**
     * Retorna o label do badge com base no valor da célula.
     * Se não houver mapeamento, usa o padrão ou o próprio valor.
     */
    $_badgeLabel(valor, badge) {
      const entrada = badge.map?.[valor];
      if (entrada) return entrada.label ?? valor;
      return badge.padrao?.label ?? valor ?? '- - -';
    },

    /**
     * Retorna o estilo inline do badge (cor de fundo, texto e bolinha).
     * Suporta nomes de cores (green, red, orange, blue, grey, purple)
     * ou qualquer valor CSS válido (ex: '#ff5722', 'hsl(200,80%,40%)').
     */
    $_badgeEstilo(valor, badge) {
      const CORES_PALETA = {
        green: { bg: '#e8f5e9', texto: '#2e7d32', bolinha: '#4CAF50' },
        red: { bg: '#ffebee', texto: '#c62828', bolinha: '#f44336' },
        orange: { bg: '#fff3e0', texto: '#e65100', bolinha: '#ff9800' },
        blue: { bg: '#e3f2fd', texto: '#1565c0', bolinha: '#2196F3' },
        grey: { bg: '#f5f5f5', texto: '#424242', bolinha: '#9e9e9e' },
        purple: { bg: '#f3e5f5', texto: '#6a1b9a', bolinha: '#9c27b0' },
        yellow: { bg: '#fffde7', texto: '#f57f17', bolinha: '#ffc107' },
      };

      const entrada = badge.map?.[valor] ?? badge.padrao ?? {};
      const corChave = entrada.cor ?? '---';
      const paleta = CORES_PALETA[corChave];

      if (paleta) {
        return {
          '--badge-bg': paleta.bg,
          '--badge-texto': paleta.texto,
          '--badge-bolinha': paleta.bolinha,
        };
      }

      // Cor customizada (hex, rgb, etc.)
      return {
        '--badge-bg': `${corChave}22`,
        '--badge-texto': corChave,
        '--badge-bolinha': corChave,
      };
    },

    $_mudarTabela() {
      this.mostrarResumo = !this.mostrarResumo;
      const el = this.$refs.simplebar.$el.querySelector('.simplebar-content-wrapper');
      el.scrollTop = 0;
    },
    $_mudarResumo(index) {
      this.indiceAgrupamentoAtivo = index;
      const el = this.$refs.simplebar.$el.querySelector('.simplebar-content-wrapper');
      el.scrollTop = 0;
    },
  },

};
</script>
<style scoped>

.centro {
  margin:auto;
}

.table-container {
  width: 100%;
  overflow: none;
  padding: 0px;
  max-height: 510px;
}

.table {
  min-width: 100%;
  width: max-content;
}

.table__tr > td {
  text-align: center;
  padding-block: 2px;

  font-size: 0.8rem;
}

.table__tr--dark-background {
  background-color: #eee;
}

@media screen and (min-width: 1000px ) {
  .table-container {
    overflow: none !important;
  }
}

/deep/ .simplebar-scrollbar::before{
  background-color: #4CAF50 !important;
}
/deep/ .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}
/deep/ .simplebar-track.simplebar-vertical {
  width: 10px !important;
}

.reverso {
  text-align: right !important;
  padding-right: 20px;
}
.row-total {
  height: 36px;
}
.row-total td{
  font-weight: 600;
  font-size: 0.9rem;
}
.detalhar {
  display: flex;
  justify-content: left;
}
.colunas {
  position: sticky;
  top:0;
  background-color: #4CAF50;
  color: white;
  z-index: 1;
}

.grupo-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.grupo-header th {
  background: #549159;
  font-size: 0.75rem;
  text-align: center;
  color: white;
}

.grupo-empty{
  background: white !important;
}

.empty-state {
  padding: 60px 40px !important;
  text-align: center;
}

.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.empty-state-icon {
  color: #bdbdbd !important;
  opacity: 0.6;
  margin-bottom: 8px;
}

.empty-state-title {
  font-size: 18px;
  font-weight: 600;
  color: #424242;
  margin: 0;
}

.empty-state-subtitle {
  font-size: 14px;
  color: #757575;
  margin: 0;
}

.td-texto {
  text-align: left !important;
  padding-left: 10px;
  padding-right: 10px;
}
.td-numero {
  text-align: right !important;
  padding-right: 10px;
}

.destaque {
  font-weight: bold;
  font-size: 1.05em !important;
}

.table__tr--total, .table__tr--total td {
  font-size: 1.1rem;
  font-weight: 800;
  text-transform: uppercase;
  padding-top: 12px;
  padding-bottom: 12px;
}

.sticky-total {
  position: sticky;
  bottom: 0;
  background: #fff; /* ou cor da sua tabela */
  z-index: 3;
}

/* AGRUPAMENTO */
.resumo-agrupamentos-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}
.resumo-agrupamentos {
  display: flex;
  justify-self: center;
  margin: auto;
  flex-wrap: nowrap;
  margin-bottom: 10px;
  gap: 6px;
  min-width: max-content;
}
.resumo-tab {
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0);
}

.btn-agrupamento {
  white-space: nowrap;
  flex-shrink: 0;
  padding: 6px 14px;
  align-self: center;
  border-radius: 6px;
  background-color: transparent;
  font-size: 0.85rem;
  font-weight: 500;
  color: #4CAF50;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
}

.btn-agrupamento:hover {
  background-color: rgba(#4CAF50, 0.08);
}

.btn-agrupamento--ativo {
  background-color: #4CAF50;
  color: #fff;
  box-shadow: 0 2px 6px rgba(#4CAF50, 0.35);
}

.col-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 7px;
  border-radius: 999px;
  background-color: var(--badge-bg, #f5f5f5);
  color: var(--badge-texto, #424242);
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.col-badge__bolinha {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--badge-bolinha, #9e9e9e);
  flex-shrink: 0;
}

.col-badge--icone {
  padding: 4px;
  width: 20px;
  height: 20px;
  justify-content: center;
}

.col-badge--icone .col-badge__bolinha {
  width: 10px;
  height: 10px;
}

.btn-agrupamento:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(#4CAF50, 0.4);
}
</style>
